import { MarkdownReaderPage } from "./components/markdown-reader";
import ErrorBoundary from "./components/error-boundary";
import "./styles/globals.css";
import "./styles/markdown.css";
import "./styles/reader.css";
import "katex/dist/katex.min.css";
import "./styles/hljs-themes.css";

export default function App() {
  return (
    <ErrorBoundary>
      <MarkdownReaderPage />
    </ErrorBoundary>
  );
}
